import Api from "@/api.js"
import axios from "@/lib/axios.js"
import { writable } from "svelte/store";
import { success, failure } from "@/lib/toast.js";

export const contacts = writable();
export const contact = writable();

class ContactApi extends Api {
    constructor() {
        super('/api/contact', contacts, contact);
    }

    async submit(data, config) {
        return await axios
            .post("/api/contact", data, config)
            .then(async (response) => {
                success("Ihre Kontaktanfrage wurde erfolgreich übermittelt");
                return response;
            })
            .catch((error) => {
                failure("Es gab einen Fehler bei der Übermittlung Ihrer Kontaktanfrage");
                return Promise.reject(error);
            });
    }
}

export const api = new ContactApi('/api/contact', contacts, contact);